import { z } from "zod/v3";

/** Что известно о сборке: подставляется Vite при сборке, секретов здесь нет. */
export interface BuildInfo {
  version: string;
  commit: string;
  /** Момент сборки в ISO 8601 (UTC). */
  builtAt: string;
}

export const buildInfo: BuildInfo = {
  version: __APP_VERSION__,
  commit: __APP_COMMIT__,
  builtAt: __APP_BUILT_AT__,
};

const appEnvironmentSchema = z.enum([
  "local",
  "testing",
  "staging",
  "production",
]);

export type AppEnvironment = z.infer<typeof appEnvironmentSchema>;

/** Окружение сборки; null, если значение не задано или неизвестно. */
export function appEnvironment(
  values: Record<string, unknown> = import.meta.env,
): AppEnvironment | null {
  const parsed = appEnvironmentSchema.safeParse(values.VITE_APP_ENV);

  return parsed.success ? parsed.data : null;
}

/** Коммит короче: полный хеш нужен только тому, кто ищет его в репозитории. */
export function shortCommit(commit: string): string {
  return /^[0-9a-f]{40}$/i.test(commit) ? commit.slice(0, 12) : commit;
}

/** Время сборки для человека; нечитаемое значение показываем как есть. */
export function formatBuiltAt(value: string, locale = "ru-RU"): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return new Intl.DateTimeFormat(locale, {
    dateStyle: "long",
    timeStyle: "short",
  }).format(date);
}
